export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./login.vue?vue&type=template&id=b210dc4a"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/login/login.vue?vue&type=template&id=b210dc4a
// module id = 3P2v
// module chunks = 0